'use client';

import type { MouseEvent } from 'react';

import RichText from '@/components/ui/RichText/RichText';
import type { ArticleTocSection } from './types';

const scrollToTocItem = (event: MouseEvent<HTMLAnchorElement>, id: string) => {
  // rehypeSanitize prefixes ids with "user-content-" to prevent clobbering
  const target =
    document.getElementById(`user-content-${id}`) ??
    document.getElementById(id);

  if (!target) {
    return;
  }

  event.preventDefault();
  window.history.pushState(null, '', `#${id}`);

  const header = document.querySelector('header');
  const headerBottom = header ? header.getBoundingClientRect().bottom : 0;
  const top =
    target.getBoundingClientRect().top + window.scrollY - headerBottom - 16;
  window.scrollTo({ top, behavior: 'smooth' });
};

export default function ArticleTableOfContents({
  toc,
}: {
  toc: ArticleTocSection;
}) {
  let headingNum = 0;

  return (
    <div className="my-8 border-y border-gray-200 py-6">
      <RichText styles={toc.heading.styles}>{toc.heading.content}</RichText>
      <ul>
        {toc.content.map((item, i) => {
          if (!item.subItem) headingNum++;
          const isLastInGroup =
            !toc.content[i + 1] || !toc.content[i + 1].subItem;
          return (
            <li
              key={item.id}
              className={`flex items-center gap-3 ${item.subItem ? 'ml-6' : ''} ${isLastInGroup ? 'pb-3' : 'pb-1'}`}
            >
              {item.subItem ? (
                <span className="bg-gray-150 ml-2 h-2 w-2 shrink-0 rounded-full" />
              ) : (
                <span className="bg-gray-150 flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-sm font-semibold text-(--color-gray-cool)">
                  {headingNum}
                </span>
              )}
              <a
                href={`#${item.id}`}
                className={toc.styles?.p ?? ''}
                onClick={(event) => scrollToTocItem(event, item.id)}
              >
                {item.text}
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
